import { useMemo, useContext } from 'react';
import { useCurrentInstitution } from 'jotaiAtoms/currentInstitution';
import { useAppQuery } from 'services/reactQuery/useAppQuery';
import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { SimpleSelectElement } from 'components/molecules';
import { formFields } from 'consts/form/formFields';

import { settlementTexts } from 'consts/text';
import { CourseFullDTO } from 'types';
import { AppFormContext } from 'contexts/AppFormContext';
import { useDisplayFetchDataError } from 'hooks/useDisplayFetchDataError/useDisplayFetchDataError';

const fetchingCoursesError =
    'Nie udało się pobrać danych o zajęciach dodatkowych, odśwież stronę i spróbuj ponownie';

export const CoursePicker = () => {
    const { formError, setFormError } = useContext(AppFormContext);
    const { id: institutionId } = useCurrentInstitution();

    const {
        data: coursesData,
        isFetching: isCoursesLoading,
        isError: isCoursesError,
    } = useAppQuery('COURSES', [institutionId], () =>
        StaffHTTPService.courses.getCourses(institutionId),
    );

    useDisplayFetchDataError({
        isFetching: isCoursesLoading,
        isError: isCoursesError,
        actualError: formError,
        errorMessage: fetchingCoursesError,
        setError: setFormError,
    });

    const courseOptions = useMemo(() => {
        if (!coursesData?.content) {
            return [];
        }
        return coursesData.content.map((course: CourseFullDTO) => ({
            label: course.courseDto.name,
            value: course.courseDto.id,
        }));
    }, [coursesData]);

    return (
        <SimpleSelectElement
            name={formFields.refersToCourses}
            label={settlementTexts.children.costAllocation.courses}
            options={courseOptions}
            mode="multiple"
            loading={isCoursesLoading}
            placeholder={settlementTexts.children.costAllocation.selectCourses}
        />
    );
};
